import React, { createContext, useRef, useMemo, useContext } from 'react';

const DropdownContext = createContext(null);
const DropdownProvider = ({ children }) => {
    const rootRef = useRef(null);
    const value = useMemo(() => ({
        rootTriggerRef: rootRef,
    }), []);
    return (React.createElement(DropdownContext.Provider, { value: value }, children));
};
const useDropdown = () => {
    const context = useContext(DropdownContext);
    if (!context) {
        throw new Error('useDropdown must be used whithin DropdownProvider');
    }
    return context;
};

export { DropdownProvider, useDropdown };
